import {
  MapPin,
  Clock,
  Gift,
  Percent,
  Ticket,
  ScanLine,
  BellRing,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

const columns = [
  {
    title: "Fidélisation",
    subtitle: "Faites revenir vos clients",
    accent: "bg-coral/10 text-coral",
    items: [
      { icon: BellRing, label: "Message push instantané ou planifié, ciblé par audience", live: true },
      { icon: MapPin, label: "Notif géolocalisée quand le client passe à côté", live: true },
      { icon: Clock, label: "Relance automatique des clients inactifs", live: true },
      { icon: Percent, label: "Tampons, cashback ou points — au choix", live: true },
    ],
  },
  {
    title: "Opérationnel",
    subtitle: "Zéro geste en plus au comptoir",
    accent: "bg-orange/10 text-orange",
    items: [
      { icon: ScanLine, label: "Tampon ajouté en un clic depuis votre tableau de bord", live: true },
      { icon: Ticket, label: "Carte créée par le client via un QR affiché en caisse", live: true },
    ],
  },
  {
    title: "Croissance",
    subtitle: "Au-delà de la fidélité",
    accent: "bg-mint/10 text-mint-text",
    items: [
      { icon: Gift, label: "Onboarding concierge : on configure pour vous", live: true },
      { icon: MapPin, label: "Annuaire de découverte pour attirer du monde", live: true },
    ],
  },
];

export function Features() {
  return (
    <section id="fonctionnalites" className="bg-cream-deep py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Fonctionnalités</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Tout ce qu'il faut pour fidéliser.
            <br />
            <span className="text-gradient">Rien qui manque au quotidien.</span>
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Des bases solides, plus les fonctionnalités qui font vraiment la différence
            pour les commerçants du quotidien.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {columns.map((col, colIdx) => (
            <Reveal key={col.title} delay={colIdx * 0.1}>
              <div className="flex h-full flex-col rounded-2xl border border-line bg-white p-7 shadow-card">
                <span
                  className={`inline-flex w-fit items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide ${col.accent}`}
                >
                  {col.title}
                </span>
                <p className="mt-3 text-lg font-bold text-ink">{col.subtitle}</p>

                <ul className="mt-5 flex flex-1 flex-col gap-4">
                  {col.items.map((item) => (
                    <li key={item.label} className="flex items-start gap-3">
                      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-cream-deep text-ink">
                        <item.icon size={16} />
                      </div>
                      <span className="text-sm leading-snug text-ink-soft">
                        {item.label}
                        {!item.live && (
                          <span className="ml-2 inline-flex items-center rounded-full bg-cream-deep px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-ink-soft">
                            Bientôt
                          </span>
                        )}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
